<template>
    <div id="privateGalleryContentsModal" aria-hidden="true"
         class="modal fade"
         role="dialog" tabindex="-1">
        <div class="modal-dialog modal-dialog-centered modal-gallery-contents" role="document">
            <div class="modal-content" v-if="gallery">
                <div class="modal-header gallery-contents-header">
                    <span>{{ gallery.title || translate.home.viewGallery }}</span>
                    <span class="gallery-contents-header--close" data-dismiss="modal">{{ translate.home.close }} X</span>
                </div>
                <div class="gallery-contents-tabs">
                    <button :class="{'active': activeTab === 'photos'}" @click="activeTab = 'photos'" :disabled="loading">
                        {{ translate.home.premiumPhotos }}
                        <span v-if="!loading">({{ photos.length }})</span>
                    </button>
                    <button :class="{'active': activeTab === 'videos'}" @click="activeTab = 'videos'" :disabled="loading">
                        {{ translate.home.premiumVideos }}
                        <span v-if="!loading">({{ videos.length }})</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div v-if="loading" class="gallery-contents-loading">
                        <div class="spinner-border" role="status">
                            <span class="sr-only">{{ translate.home.loading }}...</span>
                        </div>
                    </div>

                    <div v-else class="gallery-contents-grid mt-3">
                        <template v-if="activeTab === 'photos'">
                            <template v-if="photos.length > 0">
                                <div v-for="(photo, index) in photos" :key="photo.id" class="gallery-contents-item" @click="openFullscreenGallery(index)">
                                    <picture>
                                        <source :srcset="photo.urls.medium.webp" type="image/webp">
                                        <source :srcset="photo.urls.medium.jpg" type="image/jpeg">
                                        <img :src="photo.urls.medium.jpg" :alt="'Photo'">
                                    </picture>
                                </div>
                            </template>
                            <div v-else class="gallery-contents-empty">
                                <span>{{ translate.home.noPhotos }}</span>
                            </div>
                        </template>

                        <template v-if="activeTab === 'videos'">
                            <template v-if="videos.length > 0">
                                <div v-for="(video, index) in videos" :key="video.id" class="gallery-contents-item gallery-contents-item--video" @click="openFullscreenGallery(photos.length + index)">
                                    <picture v-if="video.thumbnail">
                                        <img :src="video.thumbnail" :alt="'Video'">
                                    </picture>
                                    <div class="gallery-contents-item--play">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" fill="currentColor">
                                            <path d="M14 15.06V33a2 2 0 0 0 2.93 1.77l17.09-8.97a2 2 0 0 0 0-3.54L16.93 13.3A2 2 0 0 0 14 15.06z"></path>
                                        </svg>
                                    </div>
                                </div>
                            </template>
                            <div v-else class="gallery-contents-empty">
                                <span>{{ translate.home.noVideos }}</span>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            gallery: null,
            photos: [],
            videos: [],
            activeTab: 'photos',
            loading: false,
        }
    },
    computed: {
        ...mapState(['translate']),
    },
    methods: {
        async initModal(gallery) {
            this.gallery = gallery;
            this.photos = [];
            this.videos = [];
            this.activeTab = 'photos';
            this.loading = true;

            setTimeout(() => {
                $(() => {
                    const element = $('#privateGalleryContentsModal');
                    if (element && typeof element.modal === 'function') {
                        element.modal('show');
                    }
                });
            });

            await this.fetchGalleryContents();
        },
        async fetchGalleryContents() {
            this.loading = true;

            try {
                const [photosResponse, videosResponse] = await Promise.all([
                    api.gallery.images(this.gallery.id),
                    api.gallery.videos(this.gallery.id),
                ]);

                const photosData = _.get(photosResponse, 'data', []);
                const videosData = _.get(videosResponse, 'data', []);

                this.photos = Array.isArray(photosData) ? photosData : [];
                this.videos = Array.isArray(videosData) ? videosData : [];
            } catch (err) {
                toastr.error(this.translate.home.errorCommon);
            } finally {
                this.loading = false;
            }
        },
        openFullscreenGallery(index) {
            const items = [];

            this.photos.forEach((photo) => {
                const src = _.get(photo, 'urls.default.jpg') || _.get(photo, 'urls.default.webp');
                if (src) {
                    items.push({src});
                }
            });

            this.videos.forEach((video) => {
                if (video.video_id) {
                    const isMobile = $(window).width() < 576;
                    const html = '<iframe' +
                        '  src="' + process.env.MIX_CLOUDFARE_SUBDOMAIN + '/' + video.video_id + '/iframe"' +
                        '  style="border: none"' +
                        '  height="' + (isMobile ? 380 : 720) + '"' +
                        '  width="' + (isMobile ? 500 : 1280) + '"' +
                        '  allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"' +
                        '  class="profile-video-in-fancybox-iframe"' +
                        '  allowfullscreen="true"' +
                        '></iframe>';
                    items.push(html);
                }
            });

            if (items.length > 0 && typeof $.fancybox !== 'undefined') {
                $.fancybox.open(items, {
                    loop: false,
                    buttons: ['close', 'zoom'],
                }, index);
            }
        }
    },
    beforeDestroy() {
        window.clearModalFade();
    },
}
</script>
